<template lang="pug">
  form(@submit.prevent="next")
    p.text-large - Irregularidades do Documento
    .pt-2
      .form-group(v-for='item in resource.todas_irregularidades')
        label.form-switch
          input(type='checkbox' v-model='item._selected')
          i.form-icon
          small {{ item.descricao }}
        .divider
    .py-2
      .divider
      button.btn.btn-primary(:disabled="resource.irregularidade_codigos_add.length <= 0")
        btn-content(name="next")
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [mixin],
}
</script>
